import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import IProductVariation from "@/interfaces/variation.interface";
import productVariationService from "@/services/variation.service";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetProductVariationsReturn =
  RequestsBaseReturn<PaginatedResponse<IProductVariation> | null>;

export interface UseGetProductVariationsProps extends RequestPagination {
  filters: IFilter<IProductVariation>[];
}

type GetAllSwrParams = [string, number, number, IFilter<IProductVariation>[]];

const useGetProductVariations = ({
  pageNumber,
  pageSize,
  filters,
}: UseGetProductVariationsProps): UseGetProductVariationsReturn => {
  const normalizedFilter = normalizeSingleFilterFormData(filters, "description");

  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<IProductVariation>, Error, GetAllSwrParams>(
    [SWR_KEYS.getProductVariations, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      productVariationService.filter(_filters, {
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetProductVariations;
